module.exports = __webpack_public_path__ + "src/assets/individualImages/melliferaHorns.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/melliferaHorns.png
// module id = ./src/assets/individualImages/melliferaHorns.png
// module chunks = 0